<template>
  <router-view />
</template>

<script>
export default {
	name: 'VPassThrough',
};
</script>
